
import { createTheme } from "@mui/material/styles";


const theme = createTheme({
  palette: {
    primary: {
      main: "#2b2b2b",
    },
    secondary: {
      main: "#ffa300",
    },
  },
  typography: {
    fontFamily: "Inter",
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 800,
    h1: {
      fontWeight: 600,
      fontSize: "3.0rem",
      lineHeight: 1.57,
      fontFamily: "Inter",
    },
    h2: {
      fontSize: "2.5rem",
      fontWeight: 600,
      lineHeight: 1.57,
      fontFamily: "Inter",
    },
    fontSize: 15,
    h3: {
      fontSize: "2rem",
      fontFamily: "Inter",
      fontWeight: 600,
      lineHeight: 1.42,
    },
    h4: {
      fontFamily: "Inter",
      fontSize: "2rem",
      fontWeight: 600,
      lineHeight: 1.53,
    },
    h5: {
      fontFamily: "Inter",
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: 1.74,
    },
    h6: {
      fontSize: "1.2rem",
      fontWeight: 600,
      lineHeight: 1.84,
      fontFamily: "Inter",
    },
    subtitle1: {
      fontFamily: "Inter",
      fontSize: "1.1rem",
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: "1.1rem",
    },
    body1: {
      fontSize: "1rem",
      fontFamily: "Inter",
    },
    body2: {
      fontFamily: "Inter",
      fontSize: "1rem",
    },
    button: {
      fontFamily: "Inter",
      fontSize: "1rem",
      lineHeight: 1.95,
    },
    caption: {
      fontFamily: "Inter",
      fontSize: "1rem",
    },
  },
  components: {
    MuiCardContent: {
      styleOverrides: {
        root: {
          justifyContent: "center",
          justifySelf: "center",
        },
      },
    },
  },
});
export default theme;